import { RadioButton } from "primereact/radiobutton";

const BaseRadioButton = (props)=>{
    return <RadioButton {...props}></RadioButton>
}

export default BaseRadioButton;